import React, { useContext, useState } from "react";
import { Spinner } from "reactstrap";
import { Language } from "../../App";

// -webkit-line-clamp only caps the bio at 3 lines when it's long enough to
// need it — a 1-line bio still collapses to 1 line's height, so shorter
// bios left the buttons below sitting at a different position card to
// card. minHeight reserves the full 3-line block regardless of actual
// length: 3 lines * (12px font-size * 1.6 line-height) = ~58px, plus this
// paragraph's own 8px top padding and 1px top border (box-sizing: border-box
// from Bootstrap's reboot, so min-height covers padding + border too).
const bioStyle = {
  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  minHeight: "67px",
};

function MentorshipCard({ mentor, onViewProfile, onApply }) {
  const { lang } = useContext(Language);
  const [photoLoaded, setPhotoLoaded] = useState(false);

  const handleViewProfile = () => {
    onViewProfile?.(mentor);
  };
  return (
    <div
      className="mentorship-card-cap"
      onClick={handleViewProfile}
      style={{
        width: "100%",
        maxWidth: "310px",
        borderRadius: "26px",
        border: "0.5px solid #D7E0EA",
        background: "linear-gradient(180deg, #DAFAFF 0px, #EFFDFF 180px, #FFFFFF 100px, #FFFFFF 100%)",
        padding: "12px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        cursor: "pointer",
      }}
    >
      {/* Doctor Photo */}
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          position: "relative",
          width: "100%",
          height: "210px",
          borderRadius: "24px",
          overflow: "hidden",
          border: "2px solid #FFFFFF",
          background: "#F7FDFF",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: photoLoaded ? 0 : 1,
            transition: "opacity 0.35s ease-out",
            pointerEvents: "none",
            zIndex: 1,
          }}
        >
          <Spinner style={{ color: "#1dc1dd" }} />
        </div>
        <img
          src={mentor.image}
          alt={mentor.name}
          onLoad={() => setPhotoLoaded(true)}
          className="object-cover"
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            opacity: photoLoaded ? 1 : 0,
            transition: "opacity 0.45s cubic-bezier(0.16, 1, 0.3, 1)",
            willChange: "opacity",
          }}
        />
      </div>

      {/* Name / Specialty / Bio */}
      <div style={{ textAlign: "center" }}>
        <p
          className="roboto-bold text-truncate"
          style={{
            fontWeight: 600,
            fontSize: "16px",
            color: "#0F1A2B",
            margin: "0 0 6px",
          }}
          title={mentor.name}
        >
          {mentor.name}
        </p>

        <span
          className="roboto-medium"
          style={{
            display: "inline-block",
            background: "#1DC1DD33",
            color: "#000000",
            fontWeight: 500,
            fontSize: "12px",
            padding: "3px 14px",
            borderRadius: "6px",

          }}
        >
          {mentor.specialty}
        </span>

        <hr
          style={{
            border: "none",
            borderTop: "1px solid #EAEEF2",
            margin: "0 0 10px",
          }}
        />

        <p
          className="roboto-regular"
          style={{
            fontSize: "12px",
            color: "#848798",
            lineHeight: 1.6,
            fontWeight: 500,
            textAlign: "center",
            borderTop: "1px solid #E6E7EA",
            paddingTop: "8px",
            margin: 0,
            ...bioStyle,
          }}
        >
          {mentor.bio}
        </p>
      </div>

      {/* Buttons */}
      <div>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            handleViewProfile();
          }}
          className="roboto-medium"
          style={{
            display: "block",
            width: "100%",
            fontWeight: 600,
            fontSize: "12px",
            color: "#1DC1DD",
            background: "#1DC1DD0A",
            border: "0.5px solid #1DC1DD",
            borderRadius: "999px",
            padding: "9px 1rem",
            marginBottom: "10px",
            cursor: "pointer",
            letterSpacing: "0.01em",
          }}
        >
          {lang?.see_complete_profile || "View Profile"}
        </button>

        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onApply?.(mentor);
          }}
          className="roboto-bold"
          style={{
            display: "block",
            width: "100%",
            fontWeight: 600,
            fontSize: "12px",
            color: "#ffffff",
            background: "#061223",
            border: "none",
            borderRadius: "999px",
            padding: "11px 1rem",
            cursor: "pointer",
            letterSpacing: "0.01em",
          }}
        >
          {lang?.mentorship_apply_for_mentorship_button || "Apply for Mentorship"}
        </button>
      </div>
    </div>
  );
}

export default React.memo(MentorshipCard);
